import React, { useContext, useEffect, useRef, useState } from 'react'
import { DownloadTableExcel } from 'react-export-table-to-excel';
import MsgUtils from '../Tools/MsgUtils';
import ItemInventario from './ItemInventario';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;
const meses = [{ id: 1, nombre: 'ENERO' }, { id: 2, nombre: 'FEBRERO' }, { id: 3, nombre: 'MARZO' }, { id: 4, nombre: 'ABRIL' },
{ id: 5, nombre: 'MAYO' }, { id: 6, nombre: 'JUNIO' }, { id: 7, nombre: 'JULIO' }, { id: 8, nombre: 'AGOSTO' }, { id: 9, nombre: 'SEPTIEMBRE' }
    , { id: 10, nombre: 'OCTUBRE' }, { id: 11, nombre: 'NOVIEMBRE' }, { id: 12, nombre: 'DICIEMBRE' }]
const productos = [{ id: 1, nombre: 'POLLO', ids: "(10,11,12,13)" }, { id: 2, nombre: 'PIPOCA', ids: "(134)" }, { id: 3, nombre: 'HELADOS', ids: "(110,112,113,114)" },
{ id: 4, nombre: 'ARROZ', ids: "(121,122)" }]
function HistoricoVnetas() {
    const { loading, setLoading } = useContext(ContextGloball);
    const myTabla = useRef(null);
    const [listaSucursal, setListaSucursal] = useState([]);
    const [regional, setRegional] = useState(JSON.parse(localStorage.getItem('info')).ID_REGIONAL_ACTUAL);
    const [idSucursal, setIdSucursal] = useState(-1);
    const [anio, setAnio] = useState(new Date().getFullYear() - 1);
    const [aniod, setAniod] = useState(new Date().getFullYear() - 2);
    const [listaMes, setListaMes] = useState([]);
    const [mes, setMes] = useState(-1);
    const [ventasInfo, setVentasInfo] = useState([]);
    const [idProducto, setIdProducto] = useState(-1);
    const [productoFiltro, setProductoFiltro] = useState(null);
    function getSucursales() {
        fetch(`${server}/sqlComun/getSucursales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: regional
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setListaSucursal(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }
    function obtenerInformacion() {
        console.log("obteniendo informacion")
        fetch(`${server}/reporte/getHistoricoVentas`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: regional.toString(), idSucursal, mes, anio, aniod, ids: productoFiltro == null ? '(-1)' : productoFiltro
            })
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                if (data.ok) {
                    console.log(data.ok);
                    setVentasInfo(data.ok);
                    setListaMes(meses);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }
    function obtenerReporteVenta() {
        if (idProducto !== -1) {
            setListaMes([]);
            if (mes != -1) {
                setLoading(true);
                var auxMeses = meses.filter((item) => item.id == mes);
                setListaMes(auxMeses);
            } else {
                setLoading(true);
                obtenerInformacion();
            }
        } else {
            MsgUtils.msgError("Escoje un porducto Por favor..");
        }
    }
    useEffect(() => {
        if (listaSucursal.length == 0) {
            getSucursales();
        }
    }, [])
    return (
        <>
            <div className='container-fluid bg-dark bg-gradient py-1'>
                <div className='row row-cols g-1' style={{marginRight:'40px'}}>
                    <div className='col' style={{ maxWidth: '120px', minWidth: '120px' }}>
                        <div className="forms-inputs forms-inputs-sm">
                            <span className="text-light" style={{ border: 'none' }}>Producto</span>
                            <select className="form-select btn btn-secondary btn-sm text-start" value={idProducto}
                                onChange={(e) => {
                                    if (e.target.value == -1) {
                                        setProductoFiltro(null);
                                    } else {
                                        var aux = productos.filter((item) => item.id == e.target.value);
                                        setProductoFiltro(aux[0].ids);
                                    }
                                    setIdProducto(e.target.value);
                                    setListaMes([]);
                                }}>
                                <option value='-1'>NINGUNO</option>
                                {productos.map((item, i) => {
                                    return <option value={item.id} key={i}>{item.nombre}</option>
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '150px', minWidth: '150px' }}>
                        <div className="forms-inputs forms-inputs-sm">
                            <span className='text-light'>Sucursal</span>
                            <select className="form-select btn btn-secondary btn-sm text-start" value={idSucursal} onChange={(e) => { setIdSucursal(e.target.value); setListaMes([]); }}>
                                <option value='-1'>--TODAS--</option>
                                {listaSucursal.map((item, i) => {
                                    return <option value={item.ID_SUCURSAL} key={item.ID_SUCURSAL}>{item.SUCURSAL}</option>
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '150px', minWidth: '150px' }}>
                        <div className="forms-inputs forms-inputs-sm">
                            <span className='text-light'>Mes</span>
                            <select className="form-select btn btn-secondary btn-sm text-start" value={mes} onChange={(e) => { setMes(e.target.value); setListaMes([]); }}>
                                <option value='-1'>ANUAL</option>
                                {meses.map((item, i) => {
                                    return <option value={item.id} key={i}>{item.nombre}</option>
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '180px', minWidth: '180px' }}>
                        <div className="forms-inputs forms-inputs-sm text-center">
                            <span className="text-light " style={{ border: 'none' }}>Comparar Año</span>
                            <div className="input-group input-group-sm">
                                <input type="NUMBER" className="form-control form-control-sm" placeholder="AÑO" value={anio} onChange={(e) => { setAnio(e.target.value); setListaMes([]); }} />
                                <span className="input-group-text" id="basic-addon1">CON</span>
                                <input type="NUMBER" className="form-control form-control-sm" placeholder="AÑO" value={aniod} onChange={(e) => { setAniod(e.target.value); setListaMes([]); }} />
                            </div>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '60px', minWidth: '60px' }}>
                        <div className="forms-inputs forms-inputs-sm">
                            <span className="text-light" style={{ border: 'none' }}>Buscar</span>
                            <button className='btn btn-light bg-gradient btn-sm w-100' onClick={() => obtenerReporteVenta()}><i className="fa-solid fa-magnifying-glass"></i></button>
                        </div>
                    </div>
                    {listaMes.length !== 0 &&
                        <div className='col' style={{ maxWidth: '90px', minWidth: '90px' }}>
                            <div className="forms-inputs forms-inputs-sm">
                                <span className="text-light" style={{ border: 'none' }}>Exportar</span>
                                <DownloadTableExcel
                                    filename="Reporte ventas"
                                    sheet="Productos"
                                    currentTableRef={myTabla.current}
                                >
                                    <button className='btn btn-success bg-gradient btn-sm'><i className="fa-solid fa-file-excel"></i> Excel </button>
                                </DownloadTableExcel>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className='table-responsive py-2'>
                <table className="table table-sm table-dark tabla-bordered border-light" ref={myTabla}>
                    <thead>
                        <tr>
                            <th>MES</th>
                            <th>PRODUCTO</th>
                            <th>CANTIDAD {anio}</th>
                            <th>CANTIDAD {aniod}</th>
                            <th>UNIDAD</th>
                        </tr>
                    </thead>
                    {listaMes.length !== 0 && <tbody>
                        {listaMes.map((item, index) => {
                            return (<ItemInventario key={index} regional={regional.toString()}
                                productosFiltro={productoFiltro == null ? '(-1)' : productoFiltro}
                                idSucursal={idSucursal} item={item} anio={[anio, aniod]} mes={mes}
                                ventaInfo={ventasInfo.length == 0 ? [] : ventasInfo[index].ventas}
                                setLoading={setLoading} idProducto={idProducto} />)
                        })}
                    </tbody>}
                </table>
            </div>
        </>
    )
}

export default HistoricoVnetas